import React from 'react';
import Layout from '../../components/layout/Layout';

import './PrescriptionPage.css';

const PrescriptionPage = () => {
  return (
    <div className="prescription-page" id="prescription-page">
      <Layout>
        {/* <Row gutter={[24, 24]}>
          <Col span={24}>
            <Card className="card-container" bordered={false}>
              <Title level={2} id="cid-tuss-title">
                Pesquisar Código CID/TUSS
              </Title>
            </Card>
          </Col>
          <Col span={24}>
            <Card className="card-container" bordered={false}>
              <Title level={2} id="prescription-editor-title">
                Editor de Prescrição
              </Title>
              <PrescriptionEditor />
            </Card>
          </Col>

          <Col span={24}>
            <Card className="card-container" bordered={false}>
              <Title level={2} id="smart-suggestions-title">
                Sugestões Inteligentes
              </Title>
              <SmartSuggestions onSelect={(value) => console.log(value)} />
            </Card>
          </Col>

          <Col span={24}>
            <Card className="card-container" bordered={false}>
              <Title level={2} id="prescription-history-title">
                Histórico de Prescrições
              </Title>
              <PrescriptionHistory prescriptions={[]} />
            </Card>
          </Col>

          <Col span={24}>
            <Card className="card-container" bordered={false}>
              <Title level={2} id="external-service-integration-title">
                Integração com Serviços Externos
              </Title>
              <ExternalServiceIntegration />
            </Card>
          </Col>

          <Col span={24} className="pagination-container">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </Col>
        </Row>
        <QuickActionButton onAction={() => console.log('Nova Prescrição')} />
        <ActionFeedback /> */}
      </Layout>
    </div>
  );
};

export default PrescriptionPage;
